var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Select } from "@gravity-ui/uikit";
export var FormSelect = function (props) {
    var control = useFormContext().control;
    return (_jsx(Controller, { control: props.control || control, name: props.name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsx(Select, __assign({}, props, field, { value: field.value, id: props.name, errorMessage: (_b = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _b === void 0 ? void 0 : _b.message, validationState: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) ? "invalid" : undefined, onUpdate: function (value) {
                    var _a;
                    field.onChange(value);
                    (_a = props.onUpdate) === null || _a === void 0 ? void 0 : _a.call(props, value);
                } })));
        } }));
};
